export const DragHandlerIcon = () => {
    return (
        <div className="d-flex drag-handler-container">
            <i className='fi-dots-vertical m-0 text-muted'></i>
            <i className='fi-dots-vertical m-0 text-muted'></i>
        </div>
    )
}